/**
 * The per-release blind-mode control (1B-4b Phase 3, DEC-2026-08-04-042).
 *
 * Three states, and the third is the one worth having:
 *
 * - **blind** — "rate it to see", plus a way out;
 * - **not blind** — a way in;
 * - **overridden** — either of the above, *pinned* against the account
 *   setting, with a way back to following it. Without that third control a
 *   per-release toggle silently pins the release forever, and somebody who
 *   later turns blind mode on globally would find one album mysteriously
 *   exempt with nothing on the page admitting why.
 *
 * Links rather than a switch: this is a rare, deliberate act on a page whose
 * primary job is a slider, and a switch beside a slider reads as part of it.
 */
export default function BlindControl({ blind, override, busy, onSet }) {
  return (
    <div className="blind-control">
      <button
        type="button"
        className="link-button"
        disabled={busy}
        onClick={() => onSet(!blind)}
      >
        {blind ? 'Show other scores for this release' : 'Hide other scores until I rate this'}
      </button>
      {override === null || override === undefined ? null : (
        <button type="button" className="link-button" disabled={busy} onClick={() => onSet(null)}>
          Follow my account setting
        </button>
      )}
    </div>
  )
}
